import api from "./api";

interface WorkStageItem {
  id: number;
  name: string;
  job_type_id: number | null;
  job_type_name: string | null;
  stage_order: number;
  description: string | null;
  created_at: string;
  updated_at: string;
}

async function listWorkStages(search?: string, jobTypeId?: number): Promise<WorkStageItem[]> {
  const params = new URLSearchParams();
  if (search) params.set("search", search);
  if (jobTypeId) params.set("job_type_id", String(jobTypeId));
  const qs = params.toString();
  return api.get<WorkStageItem[]>(`/work-stages${qs ? `?${qs}` : ""}`);
}

async function createWorkStage(data: {
  name: string;
  job_type_id?: number;
  stage_order?: number;
  description?: string;
}): Promise<{ id: number; name: string }> {
  return api.post("/work-stages", data);
}

async function updateWorkStage(
  id: number,
  data: {
    name?: string;
    job_type_id?: number;
    stage_order?: number;
    description?: string;
  }
): Promise<{ message: string; id: number }> {
  return api.put(`/work-stages/${id}`, data);
}

async function deleteWorkStage(id: number): Promise<{ message: string }> {
  return api.delete(`/work-stages/${id}`);
}

export type { WorkStageItem };
export { listWorkStages, createWorkStage, updateWorkStage, deleteWorkStage };
